module.exports = {
  apiBaseURL: 'https://researchhub.icjia-api.cloud',
  filesBaseURL: 'https://researchhub.icjia-api.cloud/uploads',
  github: 'https://github.com/icjia/researchhub-preview',
  publicPath: '/'
}
